module.exports = __webpack_public_path__ + "img/c_80.ce87a688.jpg";